import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useOrderTypeSelectProductsDict = () => {
    const { t } = useTwinTranslation()
    const dictCreateType: TwinDictionary = {
        'allProducts': { name: t('withAllProducts', 'Con todos los productos') },
        // 'selectedProducts': { name: t('fromSelectedProducts', 'A partir de los productos seleccionados') },
        'onlyMain': { name: t('onlyMainProducts', 'Solo productos principales') },
        'onlyAddons': { name: t('onlyAddons', 'Solo complementos') },
    }
    return dictCreateType
}

export default useOrderTypeSelectProductsDict